import { memo, useCallback, useState } from "react";

import { useSectionSettings } from "@react/sections/Root/SectionSettingsContext";
import { type ProductHeroSettings } from "@root/tablescape/state";
import { ProductHeroAccordionView } from "@sections/ProductHero/ProductHeroAccordion/ProductHeroAccordion.view";

type Props = {
  rating: {
    textReadMoreReviews: string;
    textReviews: string;
  };
};

const ProductHeroAccordionBase = ({ rating }: Props) => {
  const { accordionItems } = useSectionSettings<ProductHeroSettings>();

  const expandedAccordionItemIndex = accordionItems.findIndex(
    (item) => item.type === "reviews" && item.isExpanded
  );

  const [openItemIndex, setOpenItemIndex] = useState<number | null>(
    expandedAccordionItemIndex > -1 ? expandedAccordionItemIndex : null
  );

  const toggleHandler = useCallback(
    (itemIndex: number) => {
      setOpenItemIndex(itemIndex === openItemIndex ? null : itemIndex);
    },
    [openItemIndex]
  );

  return (
    <ProductHeroAccordionView
      accordionItems={accordionItems}
      onToggle={toggleHandler}
      openItemIndex={openItemIndex}
      rating={rating}
    />
  );
};

export const ProductHeroAccordion = memo(ProductHeroAccordionBase);
